import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IAdditionalItemInformation } from '@rbi-ctg/menu';

interface IAdditionalItemInfoProps {
  additionalInfo?: IAdditionalItemInformation;
}

const StyledTextIngredients = styled.p`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 8px;
  margin-top: 0;
`;

const AdditionalInfoIngredientsContainer = styled.div`
  padding: 16px;
  font-size: 14px;
`;

export const StyledAdditionalInfoIngredients = ({ additionalInfo }: IAdditionalItemInfoProps) => {
  const { formatMessage } = useIntl();

  return (
    <AdditionalInfoIngredientsContainer>
      <StyledTextIngredients>
        {formatMessage({ id: 'additionalInfoIngredients' })}
      </StyledTextIngredients>
      {additionalInfo?.additives?.locale ? (
        <div>
          <span>{additionalInfo.additives.locale}</span>
        </div>
      ) : null}
      {additionalInfo?.ingredients?.locale ? (
        <div>
          <span>{additionalInfo.ingredients.locale}</span>
        </div>
      ) : null}
      {additionalInfo?.producerDetails?.locale ? (
        <div>
          <span>{additionalInfo.producerDetails.locale}</span>
        </div>
      ) : null}
    </AdditionalInfoIngredientsContainer>
  );
};
